/* eslint-disable eqeqeq */
import { memo, useContext, useState } from "react";

import Image from "next/image";

import { Dropdown, Rate, notification } from "antd";
import moment from "moment";
import PropTypes from "prop-types";

import SimpleUserInitialsName from "shared/components/atoms/SimpleUserInitials";
import ModalDenounce from "shared/components/organisms/Denounce";
import api from "shared/infra/services/api";
import AuthContext from "shared/providers/context/AuthContext";

import { CheckCircleOutlined } from "@ant-design/icons";

import { Container, CustomMenu, IconFaEllipsisV } from "./styles";

const SingleReview = ({ review, entityId }) => {
  const { user: currentUser } = useContext(AuthContext);
  const [reviewIsDeleted, setReviewIsDeleted] = useState(false);

  async function handleDeleteReview() {
    try {
      await api.delete(`review/${review.id}`, {
        contentable_type: "App\\Review",
        contentable_id: entityId,
      });

      const args = {
        message: "Avaliação excluída com sucesso",
        description: "Sua avaliação não será mais exibida.",
        icon: <CheckCircleOutlined style={{ color: "#87d067" }} />,
        duration: 6,
      };

      notification.open(args);

      setReviewIsDeleted(true);
    } catch (error) {
      console.log("error --> ", error);
    }
  }

  const menu = () => (
    <>
      <CustomMenu>
        <CustomMenu.Item>
          {review.user.id != currentUser?.id ? (
            <ModalDenounce
              contentType="App\Review"
              entityId={review.id}
              reportedUserId={review.user.id}
              render={({ handleVisible }) => (
                <button
                  type="button"
                  onClick={handleVisible}
                  style={{
                    background: "none",
                    cursor: "pointer",
                    padding: 0,
                    border: 0,
                  }}
                >
                  Denunciar
                </button>
              )}
            />
          ) : (
            <button
              type="button"
              onClick={handleDeleteReview}
              style={{
                background: "none",
                cursor: "pointer",
                padding: 0,
                border: 0,
              }}
            >
              Remover
            </button>
          )}
        </CustomMenu.Item>
      </CustomMenu>
    </>
  );

  const username = review.user.display_name;

  return (
    <>
      {!reviewIsDeleted && (
        <Container>
          <div className="left-col">
            <div className="user-avatar">
              {review.user.photo ? (
                <Image alt="" src={review.user.photo} width={30} height={30} />
              ) : (
                <SimpleUserInitialsName fullName={username} />
              )}
            </div>
            <div className="username-and-date-container">
              <h4>
                {username.length > 16
                  ? `${username.slice(0, 16)}...`
                  : username}
              </h4>
              <span>{moment(review.created_at).format("DD/MM/YYYY")}</span>
            </div>
          </div>

          <div className="right-col">
            <Rate className="review-rate" disabled defaultValue={review.rate} />

            <p>{review.description}</p>
          </div>

          <Dropdown overlay={menu} trigger={["click"]}>
            <IconFaEllipsisV />
          </Dropdown>
        </Container>
      )}
    </>
  );
};

SingleReview.defaultProps = {
  stateArray: "reviews",
};

SingleReview.propTypes = {
  stateArray: PropTypes.string,
  review: PropTypes.object.isRequired,
  entityId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
};

export default memo(SingleReview);
